import { render, staticRenderFns } from "./MyAlbums.vue?vue&type=template&id=2609159e&"
import script from "./MyAlbums.vue?vue&type=script&lang=js&"
export * from "./MyAlbums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports